import { Eye, Layers, ShieldCheck } from "lucide-react";

import { TopBarSection } from "@/components/shared/SecaoBarraSuperior";
import { PageTabs, PageTabItem } from "@/components/shared/PageTabs";
import { RoleListTable, ModuloLegend } from "./RoleListTable";

const tabs: PageTabItem[] = [
  {
    value: "permissoes",
    label: "Cargos e Permissões",
    icon: ShieldCheck,
    content: (
      <div className="flex flex-col gap-4">
        <ModuloLegend />
        <RoleListTable variant="permissoes" />
      </div>
    ),
  },
  {
    value: "abrangencia",
    label: "Abrangência",
    icon: Layers,
    content: <RoleListTable variant="abrangencia" />,
  },
  {
    value: "sensibilidade",
    label: "Sensibilidade",
    icon: Eye,
    content: <RoleListTable variant="sensibilidade" />,
  },
];

const RolePermissionsPage = () => {
  return (
    <div className="flex flex-col space-y-6 pb-10 duration-500 animate-in fade-in">
      <TopBarSection
        entity="Controle de Acesso"
        title="Controle de Acessos"
        subtitle="Cargos e permissões, abrangência (quais registros o cargo vê) e sensibilidade (quais campos o cargo vê). A configuração é definida em código."
      />

      <PageTabs tabs={tabs} paramKey="tab" />
    </div>
  );
};

export default RolePermissionsPage;
